module.exports = __webpack_public_path__ + "media/img/favicon/apple-touch-icon-b1b486b38ccbeec5cc4e12b226675d98.png";